export const fonts = {
    body: {
        value: 'inherit',
    },
    heading: {
        value: 'inherit',
    },
};
